(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mat-space-comparison"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.mat-size-card').forEach((card) => {
  const details = card.querySelector('.mat-size-details');
  const control = details?.querySelector('summary');
  if (!details || !control || details.dataset.bound) return;
  details.dataset.bound = 'true';
  card.addEventListener('pointerenter', (event) => {
    if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) details.open = true;
  });
  card.addEventListener('pointerleave', (event) => {
    if (event.pointerType === 'mouse' && !card.querySelector(':focus-visible')) details.open = false;
  });
  card.addEventListener('focusin', (event) => {
    if (event.target.matches(':focus-visible')) details.open = true;
  });
  card.addEventListener('focusout', (event) => {
    if (!card.contains(event.relatedTarget)) details.open = false;
  });
  control.addEventListener('click', (event) => {
    if (matchMedia('(hover: hover)').matches && event.pointerType !== 'touch') {
      event.preventDefault();
      details.open = true;
    }
  });
  card.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      details.open = false;
      event.stopPropagation();
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-alignment-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alignment-description')) {
    customElements.define('alignment-description', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.root = this.closest('[id^="MainProduct-"]');
        this.copy = [...this.querySelectorAll('[data-alignment-copy]')];
        this.root?.addEventListener('change', () => this.update(), { signal: this.controller.signal });
        this.update();
      }

      update() {
        const print = this.root?.querySelector('.product-form__input--prints input:checked, variant-selects select[name*="print" i]');
        const show = print ? /align/i.test(print.value) : this.dataset.alignmentPrint === 'true';
        this.copy.forEach(element => { element.hidden = !show; });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
